var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-submit"},[_c('mt-button',{class:{ 'radius': _vm.facadeArr.indexOf('radius') >= 0 },attrs:{"type":"primary","size":"small"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.text || '保存'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }